export default "__VITE_ASSET__BJvWmbcs__"